import Code from '@/components/dashboard/Code';
import ClientCode from '@/components/dashboard/ClientCode';
import SectionActions from '@/docs/SectionActions';
import Links from '@/docs/ExampleLinks';
import { useRef } from 'react'
import SEOMetadata from '@/components/SEOMetadata';
import DocHeading from '@/docs/DocHeading';

export default function CryptoListDoc() {
  const sectionRef = useRef(null);
  return (
    <div className="api-documentation space-y-8 lg:max-w-[calc(100vw-340px)] md:max-w-[calc(100vw-80px)] max-w-[calc(100vw-30px)] overflow-hidden md:overflow-visible pb-50">
      <SEOMetadata title="List - Crypto API" description="Query list data via the Crypto API; request parameters, code examples and the response schema for the list endpoint."  canonicalUrl="https://axionquant.com/docs/01-market-data/crypto/list" />
      <DocHeading className="text-3xl font-bold text-gray-900 mb-4">List - Crypto API</DocHeading>
      <div className="space-y-12" ref={sectionRef}>

        {/* List by Category */}
        <div id="category" className="flex flex-col lg:flex-row lg:gap-8 max-w-[1600px]">
          <div className="flex-1 min-w-0 lg:pr-6 xl:pr-12">
            <div className="mb-6">
              <div className="flex flex-wrap items-center gap-4 mb-4">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                  GET
                </span>
                <code className="text-lg font-mono text-gray-800 bg-gray-50 px-3 py-1 rounded break-all">
                  /crypto/list/category
                </code>
              </div>
              <p className="text-gray-700 mb-6">
                Retrieves all unique category values available in the crypto universe. Filter by asset category.
              </p>
            </div>

            <Links links={['/crypto/list/category']} />

          </div>
          <div className="flex-1 min-w-0">
            <div className="rounded-lg p-0 !pt-0 pb-4 lg:sticky lg:top-[12px]">
              <SectionActions sectionTitle="List by Category" contentRef={sectionRef} />

              <h3 className="text-sm font-semibold mb-3">List by Category</h3>
              <div className="mb-4">
                <p className="text-gray-400 text-xs mb-2">Request</p>
                <ClientCode id="crypto.list(category)"></ClientCode>
              </div>
              <div>
                <p className="text-gray-400 text-xs mb-2">Response</p>
                <Code id="01-market-data/crypto/list-category"></Code>
              </div>
            </div>
          </div>
        </div>
        {/* List by Rating */}
        <div id="rating" className="flex flex-col lg:flex-row lg:gap-8 max-w-[1600px]">
          <div className="flex-1 min-w-0 lg:pr-6 xl:pr-12">
            <div className="mb-6">
              <div className="flex flex-wrap items-center gap-4 mb-4">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                  GET
                </span>
                <code className="text-lg font-mono text-gray-800 bg-gray-50 px-3 py-1 rounded break-all">
                  /crypto/list/rating
                </code>
              </div>
              <p className="text-gray-700 mb-6">
                Retrieves all unique rating values available in the crypto universe. Filter by analyst rating.
              </p>
            </div>

            <Links links={['/crypto/list/rating']} />

          </div>
          <div className="flex-1 min-w-0">
            <div className="rounded-lg p-0 !pt-0 pb-4 lg:sticky lg:top-[12px]">
              <SectionActions sectionTitle="List by Rating" contentRef={sectionRef} />

              <h3 className="text-sm font-semibold mb-3">List by Rating</h3>
              <div className="mb-4">
                <p className="text-gray-400 text-xs mb-2">Request</p>
                <ClientCode id="crypto.list(rating)"></ClientCode>
              </div>
              <div>
                <p className="text-gray-400 text-xs mb-2">Response</p>
                <Code id="01-market-data/crypto/list-rating"></Code>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  );
}
